/* eslint-disable no-unused-vars */
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, } from '@material-ui/core';
import React, { forwardRef, useImperativeHandle, useState, useEffect, } from 'react';
import { MenuItem } from '@material-ui/core';
import { TopLabeledTextField } from '../../../../../commons/TopLabeledTextField';
import { CustomNumberFieldInputAdornment } from '../../../../../commons/style/MUI.Styles';
import { TextWrapper, Wrapper } from './Pacing.Styles';
import { CustomNumberField } from '../../../../../commons/CustomNumberField';
var pacing = function (props, ref) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    var _u = useState('no'), clearPacing = _u[0], setClearPacing = _u[1];
    var _v = useState('none'), initialCpaMode = _v[0], setInitialCpaMode = _v[1];
    var _w = useState(0), initialCpa = _w[0], setInitialCpa = _w[1];
    var _x = useState(0), initialDuration = _x[0], setInitialDuration = _x[1];
    var _y = useState(0), abaIncrement = _y[0], setAbaIncrement = _y[1];
    var _z = useState(0), cpaModifier = _z[0], setCpaModifier = _z[1];
    var _0 = useState('none'), abaCalculation = _0[0], setAbaCalculation = _0[1];
    var _1 = useState(0), abaTargetRate = _1[0], setAbaTargetRate = _1[1];
    var _2 = useState('Initial Pacing Duration'), initialPacingDurationLabel = _2[0], setInitialPacingDurationLabel = _2[1];
    var _3 = useState(false), initialCpaModeTouched = _3[0], setInitialCpaModeTouched = _3[1];
    var _4 = useState(false), abaCalculationTouched = _4[0], setAbaCalculationTouched = _4[1];
    var _5 = useState('InitialPacingDuration'), pacingType = _5[0], setPacingType = _5[1];
    useEffect(function () {
        props.errorHandler('InitialCpa', initialCpa);
    }, [initialCpa]);
    useEffect(function () {
        if (initialCpaMode === 'duration') {
            setPacingType('InitialPacingDuration');
        }
        else {
            setPacingType('InitialPacingSamples');
        }
    }, [initialCpaMode]);
    useEffect(function () {
        props.errorHandler(pacingType, initialDuration);
    }, [initialDuration]);
    useEffect(function () {
        props.errorHandler('AbandonmentIncrement', abaIncrement);
    }, [abaIncrement]);
    useEffect(function () {
        props.errorHandler('AbaTargetRate', abaTargetRate);
    }, [abaTargetRate]);
    useEffect(function () {
        props.errorHandler('CpaModifier', cpaModifier);
    }, [cpaModifier]);
    useEffect(function () {
        if (initialCpaMode === 'duration')
            setInitialPacingDurationLabel('Initial Pacing Duration (min)');
        else if (initialCpaMode === 'samples')
            setInitialPacingDurationLabel('Initial Pacing Sample Size');
        else
            setInitialPacingDurationLabel('Initial Pacing Duration');
    }, [initialCpaMode]);
    useEffect(function () {
        if (!props.isEdit) {
            if (props.campaign.Pacing) {
                var p = props.campaign.Pacing;
                setInitialCpaMode(p.InitialCPAMode);
                setInitialCpa(p.InitialCPA);
                setInitialDuration(p.InitialDuration);
                setAbaIncrement(p.AbaIncrement);
                setCpaModifier(p.CpaModifier);
                setAbaCalculation(p.AbaCalculation);
                setAbaTargetRate(p.AbaTargetRate);
            }
            else {
                setClearPacing('no');
                setInitialCpaMode('none');
                setInitialCpa(0);
                setInitialDuration(0);
                setAbaIncrement(0);
                setCpaModifier(0);
                setAbaCalculation('none');
                setAbaTargetRate(0);
            }
        }
    }, [props.campaign, props.pacingExpanded]);
    useImperativeHandle(ref, function () { return ({
        getValues: function () {
            if (clearPacing === 'yes') {
                setInitialCpaModeTouched(true);
                setAbaCalculationTouched(true);
            }
            return {
                clearPacing: clearPacing,
                initialCpaMode: initialCpaMode,
                initialCpa: initialCpa,
                initialDuration: initialDuration,
                abaIncrement: abaIncrement,
                cpaModifier: cpaModifier,
                abaCalculation: abaCalculation,
                abaTargetRate: abaTargetRate
            };
        },
        reSet: function () {
            setInitialCpaModeTouched(false);
            setAbaCalculationTouched(false);
            setClearPacing('no');
            setInitialCpaMode('none');
            setInitialCpa(0);
            setInitialDuration(0);
            setAbaIncrement(0);
            setCpaModifier(0);
            setAbaCalculation('none');
            setAbaTargetRate(0);
        },
        setData: function (data) {
            setClearPacing(data.clearPacing);
            setInitialCpaMode(data.initialCpaMode || 'none');
            setInitialCpa(data.initialCpa || 0);
            setInitialDuration(data.initialDuration || 0);
            setAbaIncrement(data.abaIncrement || 0);
            setCpaModifier(data.cpaModifier || 0);
            setAbaCalculation(data.abaCalculation || 'none');
            setAbaTargetRate(data.abaTargetRate || 0);
        }
    }); });
    return (React.createElement(Wrapper, null,
        React.createElement(FormControl, { component: 'fieldset' },
            React.createElement(FormLabel, { component: 'legend' }, "Clear Pacing Stats at sequence start"),
            React.createElement(RadioGroup, { "aria-label": 'gender', name: 'gender1', value: clearPacing, onChange: function (e) {
                    setClearPacing(e.target.value);
                } },
                React.createElement(FormControlLabel, { value: 'yes', control: React.createElement(Radio, null), label: 'Yes' }),
                React.createElement(FormControlLabel, { value: 'no', control: React.createElement(Radio, null), label: 'No' }))),
        clearPacing === 'yes' && (React.createElement(TextWrapper, null,
            React.createElement(CustomNumberField, { name: 'initialCallsPerAgent', label: 'Initial Call per Agent', value: initialCpa, onValueChange: function (e) { return setInitialCpa(e); }, error: (_a = props.pacingErrors) === null || _a === void 0 ? void 0 : _a.InitialCpa, helperText: ((_b = props.helperText) === null || _b === void 0 ? void 0 : _b.InitialCpa) !== '' && ((_c = props.helperText) === null || _c === void 0 ? void 0 : _c.InitialCpa), fullWidth: true }),
            React.createElement(TopLabeledTextField, { name: 'initialCallsPerAgentMode', label: 'Initial Calls per Agent Mode', select: true, fullWidth: true, value: initialCpaMode, onChange: function (e) { return setInitialCpaMode(e.target.value); }, onBlur: function () { return setInitialCpaModeTouched(true); }, error: initialCpaMode === 'none' && initialCpaModeTouched, helperText: initialCpaMode === 'none' &&
                    initialCpaModeTouched &&
                    'This Field is Required' },
                React.createElement(MenuItem, { value: 'none', disabled: true, hidden: true }, "Please Select"),
                React.createElement(MenuItem, { value: 'duration' }, "Duration"),
                React.createElement(MenuItem, { value: 'samples' }, "Samples")),
            React.createElement(CustomNumberField, { name: 'initialDuration', label: initialPacingDurationLabel, value: initialDuration, onValueChange: function (e) { return setInitialDuration(e); }, error: pacingType === 'InitialPacingDuration'
                    ? (_d = props.pacingErrors) === null || _d === void 0 ? void 0 : _d.InitialPacingDuration : (_e = props.pacingErrors) === null || _e === void 0 ? void 0 : _e.InitialPacingSamples, helperText: pacingType === 'InitialPacingDuration'
                    ? ((_f = props.helperText) === null || _f === void 0 ? void 0 : _f.InitialPacingDuration) !== '' && ((_g = props.helperText) === null || _g === void 0 ? void 0 : _g.InitialPacingDuration)
                    : ((_h = props.helperText) === null || _h === void 0 ? void 0 : _h.InitialPacingSamples) !== '' && ((_j = props.helperText) === null || _j === void 0 ? void 0 : _j.InitialPacingSamples), fullWidth: true }),
            React.createElement(CustomNumberField, { name: 'abaIncrement', label: 'ABA Increment', isFloat: true, value: abaIncrement, onValueChange: function (e) { return setAbaIncrement(e); }, error: (_k = props.pacingErrors) === null || _k === void 0 ? void 0 : _k.AbandonmentIncrement, helperText: ((_l = props.helperText) === null || _l === void 0 ? void 0 : _l.AbandonmentIncrement) !== '' && ((_m = props.helperText) === null || _m === void 0 ? void 0 : _m.AbandonmentIncrement), fullWidth: true, InputProps: {
                    endAdornment: (React.createElement(CustomNumberFieldInputAdornment, { position: 'end' }, "%"))
                } }),
            React.createElement(CustomNumberField, { name: 'cpaModifier', label: 'CPA Modifier', isFloat: true, value: cpaModifier, onValueChange: function (e) { return setCpaModifier(e); }, error: (_o = props.pacingErrors) === null || _o === void 0 ? void 0 : _o.CpaModifier, helperText: ((_p = props.helperText) === null || _p === void 0 ? void 0 : _p.CpaModifier) !== '' && ((_q = props.helperText) === null || _q === void 0 ? void 0 : _q.CpaModifier), fullWidth: true, InputProps: {
                    endAdornment: (React.createElement(CustomNumberFieldInputAdornment, { position: 'end' }, "%"))
                } }),
            React.createElement(TopLabeledTextField, { name: 'abaCalculation', label: 'ABA Calculation', select: true, fullWidth: true, value: abaCalculation, onChange: function (e) { return setAbaCalculation(e.target.value); }, onBlur: function () { return setAbaCalculationTouched(true); }, error: abaCalculation === 'none' && abaCalculationTouched, helperText: abaCalculation === 'none' &&
                    abaCalculationTouched &&
                    'This Field is Required' },
                React.createElement(MenuItem, { value: 'none', disabled: true, hidden: true }, "Please Select"),
                React.createElement(MenuItem, { value: 'Calls' }, "Calls"),
                React.createElement(MenuItem, { value: 'Connects' }, "Connects"),
                React.createElement(MenuItem, { value: 'Detects' }, "Detects")),
            React.createElement(CustomNumberField, { name: 'abaTargetRate', label: 'ABA Target Rate', value: abaTargetRate, onValueChange: function (e) { return setAbaTargetRate(e); }, error: (_r = props.pacingErrors) === null || _r === void 0 ? void 0 : _r.AbaTargetRate, helperText: ((_s = props.helperText) === null || _s === void 0 ? void 0 : _s.AbaTargetRate) !== '' && ((_t = props.helperText) === null || _t === void 0 ? void 0 : _t.AbaTargetRate), fullWidth: true, InputProps: {
                    endAdornment: (React.createElement(CustomNumberFieldInputAdornment, { position: 'end' }, "%"))
                } })))));
};
export var Pacing = forwardRef(pacing);
//# sourceMappingURL=Pacing.js.map